import React, {useMemo} from 'react'

export const UploaderConfigContext = React.createContext({})
export const UploaderConfigProvider = (
  {
    children,

    jwt,
    appJwt,
    providerJwt,
    worklistViewerJwt,
    requestId,
    caseId,
    careQualityPatient,
    carequalityEnabled,

    mode,
    isApp,
    role,
    listMode,
    disabled,
    canOpenWorklist,
    withViewAllButton,
    withoutDelete,
    allowDownload,
    allowDownloadMedicalImages,
    canAddHiddenFileToCase,

    canMoveGroup,
    allowReorder,
    autoGrouping,
    canAddGroup,
    persistGroups,

    apiEndpoints,
    refreshUrl,
    patientName,

    setNotification,
    setLinkedStudies,

    removePersistedRecord,
    removeSelectedRecords,
    persistRecordInfo,

    setToBeUploaded,
    setIsUploading,
    setTotal,
    locations,
    adminUserEmail,
    eveAiSettings,
    dicomRouterOrigin,
    canRouteDicoms,
    canCreatePacs,
    showHiddenRecords,
    isSelectingRecordsDirectMessage,
    selectedDirectMessageRecords,
    setSelectedDirectMessageRecords
  }) => {
  const value = useMemo(() => ({
    jwt,
    appJwt,
    providerJwt,
    worklistViewerJwt,
    requestId,
    caseId,
    careQualityPatient,
    carequalityEnabled,

    mode,
    isApp,
    role,
    listMode,
    disabled,
    canOpenWorklist,
    withViewAllButton,
    withoutDelete,
    allowDownload,
    allowDownloadMedicalImages,
    canAddHiddenFileToCase,

    canMoveGroup,
    allowReorder,
    autoGrouping,
    canAddGroup,
    persistGroups,

    apiEndpoints,
    refreshUrl,
    patientName,

    setNotification,
    setLinkedStudies,

    removePersistedRecord,
    removeSelectedRecords,
    persistRecordInfo,

    setToBeUploaded,
    setIsUploading,
    setTotal,
    locations,
    adminUserEmail,
    eveAiSettings,
    dicomRouterOrigin,
    canRouteDicoms,
    canCreatePacs,
    showHiddenRecords,
    isSelectingRecordsDirectMessage,
    selectedDirectMessageRecords,
    setSelectedDirectMessageRecords
  }), [
    jwt, appJwt, providerJwt, worklistViewerJwt, requestId, caseId, careQualityPatient,carequalityEnabled,
    mode, isApp, role, listMode, disabled, canOpenWorklist, withViewAllButton, withoutDelete, allowDownload, allowDownloadMedicalImages,canAddHiddenFileToCase,
    canMoveGroup, allowReorder, autoGrouping, canAddGroup, persistGroups,
    apiEndpoints, refreshUrl, patientName,
    setNotification,

    locations, adminUserEmail, eveAiSettings,
    dicomRouterOrigin, canRouteDicoms, canCreatePacs, showHiddenRecords, isSelectingRecordsDirectMessage,
    selectedDirectMessageRecords, setSelectedDirectMessageRecords
  ])

  return <UploaderConfigContext.Provider value={value}>{children}</UploaderConfigContext.Provider>

}